<p-toast></p-toast>

<div class="container mx-auto px-3 py-4">
  <div class="flex flex-column md:flex-row gap-4">

    <!-- LEFT COLUMN: Intro message (only if data exists) -->
    <div class="flex-1 surface-card p-4 border-round shadow-2" *ngIf="hasData">
      <p class="text-sm text-600">
        Dear PRO Patron,<br><br>
        To the right is a statement of your PRO Patron’s Investment as of December 31, {{ selectedYear }}.
        Your Patron’s Investment is valued and restricted in accordance with the Patrons Agreement. Please refer to that
        <a href="https://members.promaster.com/Terms_Conditions.htm">agreement for additional details</a>.
        Your Patronage distribution is calculated based on profits generated by PRO and your contribution to such profits
        based on your purchases during the year ended December 31, {{ selectedYear }}.
      </p>
    </div>

    <!-- RIGHT COLUMN: Always shown -->
    <div class="flex-1 flex flex-column gap-3">

      <!-- Year Selector (only if data exists) -->
      <div *ngIf="hasData" class="surface-card p-3 border-round shadow-2">
        <div class="flex align-items-center gap-3">
          <i class="pi pi-calendar text-primary text-lg"></i>
          <label for="yearSelect" class="font-semibold text-sm">Select Year:</label>

          <p-dropdown inputId="yearSelect"
                      [options]="yearOptions"
                      [(ngModel)]="selectedYear"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select a year"
                      (onChange)="onYearChanged($event.value)"
                      class="w-full md:w-14rem">
          </p-dropdown>
        </div>
      </div>

      <!-- ✅ Payment Method: Always shown -->
      <div class="surface-card p-3 border-round shadow-2">
        <div class="flex align-items-center gap-3">
          <i class="pi pi-wallet text-primary text-lg"></i>
          <label for="paymentMethodSelect" class="font-semibold text-sm">Payment Method:</label>

          <p-selectButton inputId="paymentMethodSelect"
                          [options]="paymentOptions"
                          optionLabel="label"
                          optionValue="value"
                          [(ngModel)]="valSelect1"
                          (ngModelChange)="onOptionSelected()"
                          class="w-full md:w-14rem">
          </p-selectButton>
        </div>
      </div>

      <!-- Investment Summary (only if data exists) -->
      <div *ngIf="hasData" class="surface-card p-4 border-round shadow-2">
        <h5 class="mb-3">PRO Patron’s Investment Summary</h5>
        <div class="financial-statement">
          <div class="statement-row">
            <div class="text-left">Opening Balance</div>
            <div class="text-right">{{ investment.balance | currency }}</div>
          </div>
          <div class="statement-row">
            <div class="text-left">Patronage Dividend</div>
            <div class="text-right">{{ investment.dividend | number:'1.2-2' }}</div>
          </div>
          <div class="statement-row">
            <div class="text-left">Less: Required 15% Tax Withholding</div>
            <div class="text-right">{{ investment.taxWithholding | number:'1.2-2' }}</div>
          </div>
          <div class="statement-row" *ngIf="investment.payment">
            <div class="text-left">
              Less: Amount paid in Cash<br />
              <small class="note">(40% of Dividend minus Tax Withholding)</small>
            </div>
            <div class="text-right">({{ investment.payment | number:'1.2-2' }})</div>
          </div>
          <div class="statement-row" *ngIf="investment.credit">
            <div class="text-left">
              Amount added to Retained Credits<br />
              <small class="note">(60% of Patronage Dividend)</small>
            </div>
            <div class="text-right">{{ investment.credit | number:'1.2-2' }}</div>
          </div>
          <div class="statement-row total-row mt-3">
            <div class="text-left">Ending Balance – Patron’s Retained Credits</div>
            <div class="text-right" style="border-bottom: 1px solid #000; display: inline-block; padding-bottom: 2px;">
              {{ investment.endingBalance | number:'1.2-2' }}
            </div>
          </div>

          <!-- Stock Account -->
          <div class="statement-row border-bottom-1 pb-2 mt-4 mb-2">
            <div class="text-left">Stock Account:</div>
          </div>
          <div class="statement-row">
            <div class="text-left">Class A Common Stock</div>
            <div class="text-right" style="margin-right: 3rem;">{{ investment.shares }}</div>
            <div class="text-right">{{ investment.stockValue | number:'1.2-2' }}</div>
          </div>
          <div class="statement-row">
            <div class="text-left">Class B Common Stock</div>
            <div class="text-right" style="margin-right: 3rem;">1</div>
            <div class="text-right">$0.10</div>
          </div>
          <div class="statement-row total-row mt-3">
            <div class="text-left">Total Stock Value</div>
            <div class="text-right" style="border-bottom: 1px solid #000; display: inline-block; padding-bottom: 2px;">
              {{ investment.stockValue | number:'1.2-2' }}
            </div>
          </div>

          <!-- Final Investment Balance -->
          <div class="statement-row total-row mt-3 border-top-1 pt-3">
            <div class="text-left font-bold">PRO Patron’s Investment Balance – December 31, {{ selectedYear }}</div>
            <div class="text-right text-primary text-xl font-bold double-underline">
              {{ investment.totalValue | currency }}
            </div>
          </div>
        </div>
      </div>

      <!-- ❌ Fallback message if no data -->
      <div *ngIf="!hasData" class="surface-card p-4 border-round shadow-2 text-center text-600">
        <i class="pi pi-info-circle text-2xl text-primary mb-2"></i>
        <p>No patronage data is available for the selected year.</p>
      </div>

    </div>
  </div>
</div>
